export default function normalizeString (value) {
  return value !== "" ? value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : value
}
